import { get } from 'lodash';
import * as Constants from '../../constants';

const resetState = {
  isError: false,
  errors: [],
};
const initialState = {
  ...resetState,
  createdUser: {},
  isLoading: false,
  userRevokeResult: Constants.NONE,
  users: {
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
  organizationList: {
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
};
const getValidationErrorMessage = (payload) => payload ? get(payload, 'error.detail.devErrorMessage') : '';
export default function (state = initialState, action) {
  switch (action.type) {
    case Constants.APP_RESET:
      return {
        ...state,
        ...resetState,
        isLoading: false,
        userDeleteResult: Constants.NONE,
        userRevokeResult: Constants.NONE,
      };
    case Constants.USERS_DELETE_RESET:
      return {
        ...state,
        ...resetState,
        userDeleteResult: Constants.NONE,
      };
    case Constants.USER_REVOKE_ACCESS_RESET:
      return {
        ...state,
        ...resetState,
        userRevokeResult: Constants.NONE,
      };
    case Constants.USER_UPDATE_RESET:
      return {
        ...state,
        ...resetState,
        userUpdateResult: Constants.NONE,
      };
    case Constants.APP_LOADING:
      return {
        ...state,
        ...resetState,
        isLoading: action.isLoading,
        usersFetchResult: Constants.NONE,
      };
    case Constants.USERS_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        users: action.payload,
        usersFetchResult: Constants.SUCCESS,
      };
    case Constants.USERS_GET_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
        usersFetchResult: Constants.FAIL,
        validationError: getValidationErrorMessage(get(action, 'payload[0].response.data')),
      };
    case Constants.USER_ORGANIZATIONS_FILTERED_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        organizationList: action.payload,
      };
    case Constants.USER_ORGANIZATIONS_FILTERED_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        organizationList: {
          totalPages: 1,
          totalElements: 0,
          results: [],
        },
      };
    case Constants.USER_CREATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        createdUser: action.payload,
        userCreateSuccess: true,
      };
    case Constants.USER_CREATE_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
        validationError: getValidationErrorMessage(get(action, 'payload[0].response.data')),
      };
    case Constants.USER_GET_REQUEST:
      return {
        ...state,
        isError: false,
        isLoading: true,
        errors: [],
      };
    case Constants.USER_GET_SUCCESS:
      return {
        ...state,
        isError: false,
        isLoading: false,
        errors: [],
        userDetails: action.payload,
      };
    case Constants.USER_GET_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
      };
    case Constants.USER_UPDATE_REQUEST:
      return {
        ...state,
        isError: false,
        isLoading: true,
        errors: [],
        userUpdateResult: Constants.NONE,
      };
    case Constants.USER_UPDATE_SUCCESS:
      return {
        ...state,
        isError: false,
        isLoading: false,
        errors: [],
        userUpdateResult: Constants.SUCCESS,
      };
    case Constants.USER_UPDATE_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
        userUpdateResult: Constants.FAIL,
      };
    case Constants.USER_DELETE_REQUEST:
      return {
        ...state,
        isError: false,
        isLoading: true,
        errors: [],
        userDeleteResult: Constants.NONE,
      };
    case Constants.USER_DELETE_SUCCESS:
      return {
        ...state,
        isError: false,
        isLoading: false,
        errors: [],
        userDeleteResult: Constants.SUCCESS,
      };
    case Constants.USER_DELETE_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
        userDeleteResult: Constants.FAIL,
      };
    case Constants.USER_RESEND_ACTIVATION_EMAIL_REQUEST:
      return {
        ...state,
        isError: false,
        isLoading: true,
        errors: [],
        resendActivationEmailResult: Constants.NONE,
      };
    case Constants.USER_RESEND_ACTIVATION_EMAIL_SUCCESS:
      return {
        ...state,
        isError: false,
        isLoading: false,
        errors: [],
        resendActivationEmailResult: Constants.SUCCESS,
      };
    case Constants.USER_RESEND_ACTIVATION_EMAIL_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
        resendActivationEmailResult: Constants.FAIL,
      };
    case Constants.USER_REVOKE_ACCESS_REQUEST:
      return {
        ...state,
        isLoading: true,
        userRevokeResult: Constants.NONE,
      };
    case Constants.USER_REVOKE_ACCESS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userRevokeResult: Constants.SUCCESS,
      };
    case Constants.USER_REVOKE_ACCESS_ERROR:
      return {
        ...state,
        isLoading: false,
        userRevokeResult: Constants.FAIL,
      };
      case Constants.USER_BULK_DELETE_REQUEST:
        return {
          ...state,
          isError: false,
          isLoading: true,
          errors: [],
          userBulkDeleteResult: Constants.NONE,
        };
      case Constants.USER_BULK_DELETE_SUCCESS:
        return {
          ...state,
          isError: false,
          isLoading: false,
          errors: [],
          userBulkDeleteResult: Constants.SUCCESS,
        };
      case Constants.USER_BULK_DELETE_ERROR:
        return {
          ...state,
          isError: true,
          isLoading: false,
          errors: action.payload,
          userBulkDeleteResult: Constants.FAIL,
        };
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, 'user.isLoading');
export const getIsError = (state) => get(state, 'user.isError');
export const getErrors = state => get(state, 'user.errors');

export const getUserListTotalElements = (state) => get(state, 'user.users.count');
export const getUserListResults = (state) => get(state, 'user.users.list');

export const getCreatedUser = (state) => get(state, 'user.createdUser');
export const getUserCreateSuccess = (state) => get(state, 'user.userCreateSuccess');
export const getValidationError = (state) => get(state, 'user.validationError');

export const getOrganizationListResults = (state) => get(state, 'user.organizationList.results');
export const getOrganizationListTotalCount = (state) => get(state, 'user.organizationList.totalElements');

export const getUserUpdateResult = (state) => get(state, 'user.userUpdateResult');
export const getUserDeleteResult = (state) => get(state, 'user.userDeleteResult');
export const getResendActivationEmailResult = (state) => get(state, 'user.resendActivationEmailResult');

export const getUsersFetchResult = (state) => get(state, 'user.usersFetchResult');

export const getUserRevokeAccessResult = (state) => get(state, 'user.userRevokeResult');

export const getUserDetails = (state) => get(state, 'user.userDetails');

export const getUserBulkDeleteResult = (state) => get(state, 'user.userBulkDeleteResult');
